import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { getFotoUrl } from '@/lib/utils';


interface IMembroItemProps {
    data: {
        representanteFuncao: string;
        foto?: string;
        representanteNome: string;
        representanteSubfuncao?: string;
        representanteTitulo?: string;
    }
}

const MembroItem = ({ data }: IMembroItemProps) => {
    // console.log(data)
    return (
        <div className='flex flex-col gap-3'>
            <strong className='text-xl font-semibold'>{data.representanteFuncao === 'Membro(s)' ? data.representanteFuncao.split('(')[0] : data.representanteFuncao}</strong>

            <Avatar className='w-[120px] h-[120px]'>
                <AvatarImage src={getFotoUrl(data.foto)} />                
                <AvatarFallback className='text-3xl'>{data.representanteNome.split('')[0]}</AvatarFallback>
            </Avatar>
            <p className='text-lg'>
                {data.representanteTitulo == 'Profa. Dra.' || data.representanteTitulo == 'Prof. Dr.' || data.representanteTitulo == 'Prof.Dr' || data.representanteTitulo == 'Profa.Dra' ? data.representanteTitulo : ''} {data.representanteNome} {data.representanteSubfuncao && ` - ${data.representanteSubfuncao}`}
            </p>
        </div>
    );
}

export { MembroItem };